<template>
  <div class="row">
    <div class="col-3">
      <PhotoProfile />
    </div>
    <div class="col-9">
      <div class="row">
        <div class="col-5">
          <NameAndIssue :summary="summary" :totalProject="totalProject" />
        </div>
        <div class="col-7">
          <CardOpenIssue :issue="issue" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <Project :projects="projects" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NameAndIssue from "@/components/User/NameAndIssue.vue";
import PhotoProfile from "@/components/User/PhotoProfile.vue";
import Project from "@/components/User/Project.vue";
import CardOpenIssue from "@/components/User/CardOpenIssue.vue";
import axios from "axios";

export default {
  name: "UserProfile",
  components: {
    NameAndIssue,
    PhotoProfile,
    Project,
    CardOpenIssue
  },
  data() {
    return {
      summary: [],
      totalProject: [],
      issue: [],
      projects: []
      //   cariMakanan:''
    };
  },
  methods: {
    setDataSummary(data) {
      this.summary = data.summary;
      this.totalProject = data.projects.length;
      this.issue = data.issues;
      this.projects = data.projects;

      // console.log(data)
    }
  },
  mounted() {
    var token = localStorage.token;
    document.body.classList.add("container-blue");
    axios
      .get( `issues/assigned_for/` + this.$route.params.name)
      .then(response =>
        // handle success
        // console.log(response.data.summary)
        this.setDataSummary(response.data)
      )
      .catch(error =>
        // handle error
        console.log(error)
      );
  }
};
</script>



// WEBPACK FOOTER //
// src/views/UserProfile.vue